import * as _ from 'lodash';
import { Action } from 'redux';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { ENSURE_MVNO_TEMPLATES, INITIAL_AUTHENTICATION, LOAD_MVNO_TEMPLATES } from '../../actions/actionTypes';
import { PromiseAction } from '../../actions/commonActions';
import {
  loadMvnoTemplatesFailure,
  loadMvnoTemplatesPending,
  loadMvnoTemplatesSuccess,
} from '../../actions/mvnoTemplateActions';
import * as api from '../../api/mvnoTemplateApi';
import { MvnoTemplatesState } from '../../models/state/simProvision/simProvisionState';
import { selectMvnoTemplates } from '../../selectors/mvnoTemplates';
import { AccountAndNetwork } from '../../models/account';

/*
 * A saga which fetches the list of mvno provisioning templates.
 */
export function* loadMvnoTemplatesSaga(action: PromiseAction<AccountAndNetwork, api.MvnoTemplate[]>) {
  yield put(loadMvnoTemplatesPending());
  try {
    const param = action.payload;
    if (!param) {
      yield put(loadMvnoTemplatesSuccess([]));
      return;
    }
    const accountId = param.accountId as number;
    const networkId = param.networkId as number;
    const zones: api.MvnoTemplate[] = yield call(api.getTemplates, accountId, networkId); //TODO: pass this down.
    yield put(loadMvnoTemplatesSuccess(zones));
    action.resolve && action.resolve(zones);
  } catch (error: any) {
    yield put(loadMvnoTemplatesFailure(error));
    console.error(error);
  }
}

/*
 * A saga which fetches the mvno provisioning templates if needed
 */
export function* ensureMvnoTemplatesSaga(action: Action) {
  const zonesState: MvnoTemplatesState = yield select(selectMvnoTemplates);
  const { error, isLoading } = zonesState;
  if (isLoading || error) {
    return;
  }

  yield call(loadMvnoTemplatesSaga, action);
}

/*
 * Initializes all sagas that are related to network bundle topup sizes.
 */
export function* initMvnoTemplatesSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(ENSURE_MVNO_TEMPLATES, ensureMvnoTemplatesSaga);
  yield takeEvery(LOAD_MVNO_TEMPLATES, loadMvnoTemplatesSaga);
}
